import React from 'react'
import { useSelector } from 'react-redux'
import mapping from './ItineraryHPMetaManager.json'
import { selectSeoCurrentMode } from '../../../store/itinerary/itinerary.selectors'
import { removeTrailingSlash } from '../../utils/url'
import MetaTags from '../../seo/MetaTags'
import { selectLocale } from '../../../store/navigation/navigation.selectors'
import {
  MULTIPATH_MODES_TO_SEO_MODES,
  SEO_MODE_BUS,
  SEO_MODE_CARPOOL,
  SEO_MODE_MOTORBIKE,
  SEO_MODE_PLANE,
  SEO_MODE_SCOOTER,
  SEO_MODE_TC,
  SEO_MODE_TRAIN,
} from '../../../store/itinerary/itinerary.constants'

const getItineraryPath = (seoCurrentMode) => {
  const urlFragment = MULTIPATH_MODES_TO_SEO_MODES[seoCurrentMode]
  const parts = ['itineraire']
  if (urlFragment !== '') parts.push(urlFragment)
  return '/' + parts.join('/')
}

export const getMeta = (locale, seoCurrentMode) => {
  const { title, description } = mapping?.[locale]?.[seoCurrentMode] ?? {}
  const alternateLinkPath = removeTrailingSlash(getItineraryPath(seoCurrentMode))
  return {
    title,
    description,
    alternateLinkPath,
    shouldIgnoreEn: Boolean(
      [
        SEO_MODE_TC,
        SEO_MODE_PLANE,
        SEO_MODE_BUS,
        SEO_MODE_CARPOOL,
        SEO_MODE_MOTORBIKE,
        SEO_MODE_TRAIN,
        SEO_MODE_SCOOTER,
      ].find((mode) => alternateLinkPath.includes(mode))
    ),
  }
}

export const ItineraryHPMetaManager = () => {
  const seoCurrentMode = useSelector(selectSeoCurrentMode)
  const locale = useSelector(selectLocale)

  return <MetaTags {...getMeta(locale, seoCurrentMode)} />
}

export default ItineraryHPMetaManager
